import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import Auth from './services/Auth';
import rootReducer from './reducers';

import App from './containers/App';
import NotFound from './containers/NotFound';
import UserEdit from './containers/UserEdit';
import Team from './containers/Team';
import Home from './containers/Home';
import TeamCreate from './containers/TeamCreate';
import TeamEdit from './containers/TeamEdit';
import TeamMembers from './containers/TeamMembers';
import TeamActivity from './containers/TeamActivity';

const store = createStore(rootReducer, applyMiddleware(thunk));

const Layout = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={matchProps => (
      <App auth={Auth}>
        <Component {...matchProps} />
      </App>
    )}
  />
);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Layout exact path="/" component={Home} />
        <Layout exact path="/profile/edit" component={UserEdit} />
        <Layout exact path="/teams/new" component={TeamCreate} />
        <Layout exact path="/team/:teamId" component={Team} />
        <Layout exact path="/team/:teamId/edit" component={TeamEdit} />
        <Layout exact path="/team/:teamId/activity" component={TeamActivity} />
        <Layout exact path="/team/:teamId/members" component={TeamMembers} />
        <Layout component={NotFound} />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js